/* eslint-disable import/prefer-default-export */
import { issuuList } from '../../../IssuuPreview/PreviewData';

const getLastSegmentFriendlyUrl = (productUrl) => {
  const friendlyUrlArray = productUrl.split('?')[0].split('/');
  return friendlyUrlArray[friendlyUrlArray.length - 1];
};

export const getProductTemplateCode = (productUrl) => {
  const lastSegmentFriendlyUrl = getLastSegmentFriendlyUrl(productUrl);
  const issuuListEntries = Object.entries(issuuList);
  const matchedProduct = issuuListEntries.find(issuu => issuu[1].friendly_url === lastSegmentFriendlyUrl);
  return matchedProduct && matchedProduct[0];
};



// WEBPACK FOOTER //
// ./src/Common/Helpers/CategoryPagePreview/CategoryPagePreviewHelper.js